<template>
  <ValidationProvider ref="validationProvider" :name="name || placeholder" :rules="validationRules" v-slot="{ errors }">
    <div class="tm-file-select">
      <input v-if="validationRules" type="text" :name="name || 'file-select'" :value="validationValue"
        class="tm-file-select__hidden" tabindex="-1" readonly aria-hidden="true" />
      <label v-if="name" class="tm-file-select__label">{{ name }}</label>
      <div class="tm-file-select__dropzone" :class="{ 'tm-file-select__dropzone--error': errors[0] }">
        <input ref="fileInput" type="file" class="tm-file-select__input" :accept="accept" :multiple="multiple"
          @change="onFileChange" />
        <button type="button" class="tm-file-select__trigger" @click="$refs.fileInput.click()">
          <feather-icon icon="UploadIcon" class="tm-file-select__icon" />
          <span>{{ placeholder || (multiple ? 'اختر ملفات' : 'اختر ملف') }}</span>
        </button>
      </div>
      <ul v-if="selectedFiles.length > 0" class="tm-file-select__list">
        <li v-for="(item, index) in selectedFiles" :key="item.id" class="tm-file-select__item">
          <span class="tm-file-select__item-name">{{ item.file.name }}</span>
          <button type="button" class="tm-file-select__remove" @click="removeFile(index)"
            :aria-label="'إزالة ' + item.file.name">
            <feather-icon icon="XIcon" size="14" />
          </button>
        </li>
      </ul>
      <span class="text-danger tm-file-select__error">{{ errors[0] }}</span>
    </div>
  </ValidationProvider>
</template>

<script>
let fileIdCounter = 0;

export default {
  name: 'TmFileSelect',
  props: {
    name: {
      type: String,
      default: null
    },
    value: {
      default: null,
      // validator(value) {
      //   if (value === null || value === undefined) return true;
      //   if (typeof File !== 'undefined' && value instanceof File) return true;
      //   if (Array.isArray(value)) {
      //     return value.every((item) => typeof File !== 'undefined' && item instanceof File);
      //   }
      //   return false;
      // }
    },
    placeholder: {
      type: String,
      default: null
    },
    validationRules: {
      type: [String, Object],
      default: null
    },
    accept: {
      type: String,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedFiles: []
    };
  },
  computed: {
    validationValue() {
      if (this.multiple) {
        return this.selectedFiles.length > 0 ? String(this.selectedFiles.length) : '';
      }
      return this.selectedFiles.length > 0 ? '1' : '';
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal === null || newVal === undefined) {
          this.selectedFiles = [];
          return;
        }
        if (this.multiple && Array.isArray(newVal)) {
          this.selectedFiles = newVal.map((file) => ({
            id: ++fileIdCounter,
            file
          }));
        } else if (newVal instanceof File) {
          this.selectedFiles = [{ id: ++fileIdCounter, file: newVal }];
        } else {
          this.selectedFiles = [];
        }
      }
    }
  },
  methods: {
    onFileChange(event) {
      const input = event.target;
      const files = input.files ? Array.from(input.files) : [];
      if (files.length === 0) return;

      if (this.multiple) {
        const newItems = files.map((file) => ({ id: ++fileIdCounter, file }));
        const combined = [...this.selectedFiles, ...newItems];
        this.selectedFiles = combined;
        this.emitValue(combined.map((item) => item.file));
      } else {
        this.selectedFiles = [{ id: ++fileIdCounter, file: files[0] }];
        this.emitValue(files[0]);
      }

      input.value = '';
    },
    removeFile(index) {
      this.selectedFiles.splice(index, 1);
      if (this.multiple) {
        this.emitValue(this.selectedFiles.map((item) => item.file));
      } else {
        this.emitValue(this.selectedFiles[0] ? this.selectedFiles[0].file : null);
      }
      this.$nextTick(() => {
        if (this.$refs.validationProvider && typeof this.$refs.validationProvider.validate === 'function') {
          this.$refs.validationProvider.validate();
        }
      });
    },
    emitValue(val) {
      this.$emit('input', val);
    }
  }
};
</script>

<style scoped>
.tm-file-select {
  width: 100%;
}

.tm-file-select__label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #626262;
  font-size: 14px;
}

.tm-file-select__dropzone {
  width: 100%;
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  background: #f8f9fa;
  transition: all 0.2s ease;
}

.tm-file-select__dropzone:hover {
  background: #e5e7eb;
  border-color: #e5e7eb;
}

.tm-file-select__dropzone--error {
  border-color: #f56c6c;
  background: #fef0f0;
}

.tm-file-select__input,
.tm-file-select__hidden {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  overflow: hidden;
  pointer-events: none;
}

.tm-file-select__trigger {
  width: 100%;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: #4b5563;
  outline: none;
}

.tm-file-select__icon {
  flex-shrink: 0;
}

.tm-file-select__list {
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
  max-height: 200px;
  overflow-y: auto;
}

.tm-file-select__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  margin-bottom: 6px;
  background: #f3f4f6;
  border-radius: 6px;
  font-size: 13px;
  color: #374151;
}

.tm-file-select__item-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tm-file-select__remove {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.tm-file-select__remove:hover {
  background: #e5e7eb;
  color: #dc2626;
}

.tm-file-select__error {
  display: block;
  margin-top: 6px;
  font-size: 12px;
}
</style>
